/**
 * Wize Mobile API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { ErrorResponse } from '../model/errorResponse';
// @ts-ignore
import { PortfolioDocuments } from '../model/portfolioDocuments';
// @ts-ignore
import { PortfolioMobile } from '../model/portfolioMobile';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class PortfolioMobileService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Get Document in base64
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDocuments(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<string>>;
    public getDocuments(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<string>>>;
    public getDocuments(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<string>>>;
    public getDocuments(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getDocuments.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/restful/api/mobile/financialcontainer/v1/portfolios/document/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<string>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get portfolio from id
     * @param id id
     * @param includeValuation 
     * @param forcedCalculation 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPortfolioByIdentification(id: string, includeValuation?: boolean, forcedCalculation?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<PortfolioMobile>;
    public getPortfolioByIdentification(id: string, includeValuation?: boolean, forcedCalculation?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<PortfolioMobile>>;
    public getPortfolioByIdentification(id: string, includeValuation?: boolean, forcedCalculation?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<PortfolioMobile>>;
    public getPortfolioByIdentification(id: string, includeValuation?: boolean, forcedCalculation?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getPortfolioByIdentification.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>includeValuation, 'includeValuation');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>forcedCalculation, 'forcedCalculation');

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/restful/api/mobile/financialcontainer/v1/portfolios/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PortfolioMobile>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all portfolios
     * @param includeValuation 
     * @param forcedCalculation 
     * @param userId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listMobilePortfolios(includeValuation?: boolean, forcedCalculation?: boolean, userId?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<PortfolioMobile>>;
    public listMobilePortfolios(includeValuation?: boolean, forcedCalculation?: boolean, userId?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<PortfolioMobile>>>;
    public listMobilePortfolios(includeValuation?: boolean, forcedCalculation?: boolean, userId?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<PortfolioMobile>>>;
    public listMobilePortfolios(includeValuation?: boolean, forcedCalculation?: boolean, userId?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>includeValuation, 'includeValuation');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>forcedCalculation, 'forcedCalculation');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>userId, 'userId');

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/restful/api/mobile/financialcontainer/v1/portfolios`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<PortfolioMobile>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get portfolio content
     * @param id id
     * @param includeValuation 
     * @param forcedCalculation 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listPortfolioContent(id: string, includeValuation?: boolean, forcedCalculation?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<PortfolioMobile>>;
    public listPortfolioContent(id: string, includeValuation?: boolean, forcedCalculation?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<PortfolioMobile>>>;
    public listPortfolioContent(id: string, includeValuation?: boolean, forcedCalculation?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<PortfolioMobile>>>;
    public listPortfolioContent(id: string, includeValuation?: boolean, forcedCalculation?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling listPortfolioContent.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>includeValuation, 'includeValuation');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>forcedCalculation, 'forcedCalculation');

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/restful/api/mobile/financialcontainer/v1/portfolios/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/content`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<PortfolioMobile>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List portfolio documents
     * @param id id
     * @param documentType 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listPortfolioDocuments(id: string, documentType?: 'ADVICE' | 'VALUATION' | 'PERFORMANCE' | 'STATEMENT_OF_ACCOUNT' | 'TICKET' | 'BALANCE_SHEET' | 'GENERAL_LEDGER' | 'OTHER' | 'BANK_ADVICE' | 'BANK_VALUATION' | 'BANK_PERFORMANCE' | 'BANK_STATEMENT_OF_ACCOUNT' | 'BANK_TICKET' | 'BANK_OTHER' | 'CLIENT_INTERACTION' | 'INJECTOR_RESULT' | 'ORDER_DASHBOARD' | 'VALUATION_EBANKING' | 'INVOICE' | 'CLIENT_KYC' | 'MIFID_EXANTE' | 'MIFID_SUITABILITY' | 'MIFIR_REQUEST' | 'MIFIR_RESPONSE' | 'MIFID_LOSS_ON_LEVERAGE_POSITION' | 'MIFID_LOSS_ON_PORTFOLIO' | 'SIX_TANSACTION_REPORT' | 'SIX_SUBMISSION_REPLY' | 'BANK_TAX' | 'CONSTRAINTS_ANALYSIS' | 'NAME_CHECK_REPORT' | 'TRADING_MESSAGE' | 'VALUATION_BEAN_LIST' | 'PRE_ADVICE' | 'ADVISORY_PROPOSAL' | 'CLIENT_AML' | 'CLIENT_SUITABILITY' | 'RUNNABLE_UTILITY' | 'ENCRYPTED_EXPORT' | 'ENCRYPTED_OTHER' | 'ENCRYPTED_BANK_ADVICE' | 'ENCRYPTED_BANK_VALUATION' | 'ENCRYPTED_BANK_PERFORMANCE' | 'ENCRYPTED_BANK_STATEMENT_OF_ACCOUNT' | 'ENCRYPTED_BANK_TICKET' | 'ENCRYPTED_BANK_OTHER' | 'ENCRYPTED_BANK_TAX' | 'CLIENT_ESG' | 'ENCRYPTED_INJECTOR_RESULT', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<PortfolioDocuments>>;
    public listPortfolioDocuments(id: string, documentType?: 'ADVICE' | 'VALUATION' | 'PERFORMANCE' | 'STATEMENT_OF_ACCOUNT' | 'TICKET' | 'BALANCE_SHEET' | 'GENERAL_LEDGER' | 'OTHER' | 'BANK_ADVICE' | 'BANK_VALUATION' | 'BANK_PERFORMANCE' | 'BANK_STATEMENT_OF_ACCOUNT' | 'BANK_TICKET' | 'BANK_OTHER' | 'CLIENT_INTERACTION' | 'INJECTOR_RESULT' | 'ORDER_DASHBOARD' | 'VALUATION_EBANKING' | 'INVOICE' | 'CLIENT_KYC' | 'MIFID_EXANTE' | 'MIFID_SUITABILITY' | 'MIFIR_REQUEST' | 'MIFIR_RESPONSE' | 'MIFID_LOSS_ON_LEVERAGE_POSITION' | 'MIFID_LOSS_ON_PORTFOLIO' | 'SIX_TANSACTION_REPORT' | 'SIX_SUBMISSION_REPLY' | 'BANK_TAX' | 'CONSTRAINTS_ANALYSIS' | 'NAME_CHECK_REPORT' | 'TRADING_MESSAGE' | 'VALUATION_BEAN_LIST' | 'PRE_ADVICE' | 'ADVISORY_PROPOSAL' | 'CLIENT_AML' | 'CLIENT_SUITABILITY' | 'RUNNABLE_UTILITY' | 'ENCRYPTED_EXPORT' | 'ENCRYPTED_OTHER' | 'ENCRYPTED_BANK_ADVICE' | 'ENCRYPTED_BANK_VALUATION' | 'ENCRYPTED_BANK_PERFORMANCE' | 'ENCRYPTED_BANK_STATEMENT_OF_ACCOUNT' | 'ENCRYPTED_BANK_TICKET' | 'ENCRYPTED_BANK_OTHER' | 'ENCRYPTED_BANK_TAX' | 'CLIENT_ESG' | 'ENCRYPTED_INJECTOR_RESULT', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<PortfolioDocuments>>>;
    public listPortfolioDocuments(id: string, documentType?: 'ADVICE' | 'VALUATION' | 'PERFORMANCE' | 'STATEMENT_OF_ACCOUNT' | 'TICKET' | 'BALANCE_SHEET' | 'GENERAL_LEDGER' | 'OTHER' | 'BANK_ADVICE' | 'BANK_VALUATION' | 'BANK_PERFORMANCE' | 'BANK_STATEMENT_OF_ACCOUNT' | 'BANK_TICKET' | 'BANK_OTHER' | 'CLIENT_INTERACTION' | 'INJECTOR_RESULT' | 'ORDER_DASHBOARD' | 'VALUATION_EBANKING' | 'INVOICE' | 'CLIENT_KYC' | 'MIFID_EXANTE' | 'MIFID_SUITABILITY' | 'MIFIR_REQUEST' | 'MIFIR_RESPONSE' | 'MIFID_LOSS_ON_LEVERAGE_POSITION' | 'MIFID_LOSS_ON_PORTFOLIO' | 'SIX_TANSACTION_REPORT' | 'SIX_SUBMISSION_REPLY' | 'BANK_TAX' | 'CONSTRAINTS_ANALYSIS' | 'NAME_CHECK_REPORT' | 'TRADING_MESSAGE' | 'VALUATION_BEAN_LIST' | 'PRE_ADVICE' | 'ADVISORY_PROPOSAL' | 'CLIENT_AML' | 'CLIENT_SUITABILITY' | 'RUNNABLE_UTILITY' | 'ENCRYPTED_EXPORT' | 'ENCRYPTED_OTHER' | 'ENCRYPTED_BANK_ADVICE' | 'ENCRYPTED_BANK_VALUATION' | 'ENCRYPTED_BANK_PERFORMANCE' | 'ENCRYPTED_BANK_STATEMENT_OF_ACCOUNT' | 'ENCRYPTED_BANK_TICKET' | 'ENCRYPTED_BANK_OTHER' | 'ENCRYPTED_BANK_TAX' | 'CLIENT_ESG' | 'ENCRYPTED_INJECTOR_RESULT', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<PortfolioDocuments>>>;
    public listPortfolioDocuments(id: string, documentType?: 'ADVICE' | 'VALUATION' | 'PERFORMANCE' | 'STATEMENT_OF_ACCOUNT' | 'TICKET' | 'BALANCE_SHEET' | 'GENERAL_LEDGER' | 'OTHER' | 'BANK_ADVICE' | 'BANK_VALUATION' | 'BANK_PERFORMANCE' | 'BANK_STATEMENT_OF_ACCOUNT' | 'BANK_TICKET' | 'BANK_OTHER' | 'CLIENT_INTERACTION' | 'INJECTOR_RESULT' | 'ORDER_DASHBOARD' | 'VALUATION_EBANKING' | 'INVOICE' | 'CLIENT_KYC' | 'MIFID_EXANTE' | 'MIFID_SUITABILITY' | 'MIFIR_REQUEST' | 'MIFIR_RESPONSE' | 'MIFID_LOSS_ON_LEVERAGE_POSITION' | 'MIFID_LOSS_ON_PORTFOLIO' | 'SIX_TANSACTION_REPORT' | 'SIX_SUBMISSION_REPLY' | 'BANK_TAX' | 'CONSTRAINTS_ANALYSIS' | 'NAME_CHECK_REPORT' | 'TRADING_MESSAGE' | 'VALUATION_BEAN_LIST' | 'PRE_ADVICE' | 'ADVISORY_PROPOSAL' | 'CLIENT_AML' | 'CLIENT_SUITABILITY' | 'RUNNABLE_UTILITY' | 'ENCRYPTED_EXPORT' | 'ENCRYPTED_OTHER' | 'ENCRYPTED_BANK_ADVICE' | 'ENCRYPTED_BANK_VALUATION' | 'ENCRYPTED_BANK_PERFORMANCE' | 'ENCRYPTED_BANK_STATEMENT_OF_ACCOUNT' | 'ENCRYPTED_BANK_TICKET' | 'ENCRYPTED_BANK_OTHER' | 'ENCRYPTED_BANK_TAX' | 'CLIENT_ESG' | 'ENCRYPTED_INJECTOR_RESULT', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling listPortfolioDocuments.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>documentType, 'documentType');

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/restful/api/mobile/financialcontainer/v1/portfolios/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/documents`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<PortfolioDocuments>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
